module.exports = __webpack_public_path__ + "img/小图2.8c2fdab7.png";